
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { submitToZoho } from "@/utils/secureFormSubmission";

const SubscriptionBannerSection = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email.trim()) return;

    setIsSubmitting(true);
    try {
      const success = await submitToZoho({
        firstName: '',
        lastName: '',
        email: email,
        company: '',
        message: 'MSSP Intel List subscription',
        formType: 'MSSP Email Subscription'
      });

      if (success) {
        toast.success("Thank you for subscribing! We'll keep you updated with the latest MSSP intelligence.");
        setEmail("");
      } else {
        throw new Error('Submission failed');
      }
    } catch (error) {
      toast.error("Subscription failed. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="py-16 bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0 bg-gradient-to-br from-[#8932c8]/20 to-transparent"></div>
      </div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Don't Miss a Beat in Cyber - Join Our 
            <span className="text-[#8932c8]"> MSSP Intel List</span> for Updates That Matter
          </h2>
          
          <form onSubmit={handleSubmit} className="max-w-md mx-auto">
            <div className="flex flex-col sm:flex-row gap-4">
              <Input
                type="email"
                placeholder="Enter your email now to subscribe!"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={isSubmitting}
                required
                className="flex-1 bg-white/10 border-white/20 text-white placeholder:text-gray-300 focus:bg-white/20 focus:border-[#8932c8]"
              />
              <Button 
                type="submit"
                disabled={isSubmitting}
                className="bg-[#8932c8] hover:bg-[#7a2cb3] text-white px-8 py-2 whitespace-nowrap"
              >
                {isSubmitting ? "Subscribing..." : "Subscribe"}
              </Button>
            </div>
            <p className="text-sm text-gray-400 mt-4">
              By submitting this form, you agree to our <span className="underline">Terms of Use</span> and acknowledge our privacy policy.
            </p>
          </form>
        </div>
      </div>
    </section>
  );
};

export default SubscriptionBannerSection;
